import React from 'react';

import { IndicatorProps } from '../../types/indicator';
import { VeraScoreIndicator, VeraScoreChange } from './';
import { Circle } from '../../atoms/graphs';
import { colors } from '../../styles';

export interface Props extends IndicatorProps {
  title: string;
  change?: number;
}

class VeraScoreSummary extends React.Component<Props, any> {
  public render() {
    const { className, change, risk, score, title } = this.props;
    const isValidScore = !!(score && score > 0);

    return (
      <div className={className}>
        <VeraScoreChange {...{ change, score, title }}>
          {isValidScore ? (
            <VeraScoreIndicator
              className="score-indicator"
              innerRadius={16}
              outerRadius={20}
              risk={risk}
              score={score}
            />
          ) : (
            <Circle
              className="score-indicator"
              innerRadius={16}
              outerRadius={20}
              color={colors.grey200}
              score={100}
            />
          )}
        </VeraScoreChange>
      </div>
    );
  }
}

export default VeraScoreSummary;
